import { render, staticRenderFns } from "./OnboardingSurvey.vue?vue&type=template&id=4ee9572c"
import script from "./OnboardingSurvey.vue?vue&type=script&lang=js"
export * from "./OnboardingSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports